export const validationService  = {
    validateStep(step, formData){
        switch(step){
            case 1 : 
            return this.validatePersonalInfo(formData);

            case 2:
            return this.validateAcademicInfo(formData);
            
            case 3:
            return this.validateOTP(formData); 

            default :
            return{}
        }
    },   
    validateOTP(data){
        const errors ={}

       if(!data.enteredOtp  || data.enteredOtp.length !== 4){
            errors.enteredOtp  = "OTP is required"
       }

       return errors
    },
     validatePersonalInfo(data){
        const errors = {}
        if(!data.fullname?.trim()){
            errors.fullname = "Full name is required"
        }

        if(!data.email?.trim()){
            errors.email = "Email is required"
        }else if(!this.isValidEmail(data.email)){
            errors.email = "Invalid Email Format" 
        }

        if(!data.mobile?.trim()){
            errors.mobile = "Mobile is required"
        }else if(!this.isValidMobile(data.mobile)){
            errors.mobile = "Invalid mobile format"
        }

        // ✅ Date of Birth
    if (!data.dob?.trim()) {
      errors.dob = "Date of birth is required";
    } 
    else {
      const dobError = this.isValidDob(data.dob);
      if (dobError) errors.dob = dobError;
    }

        if(!data.gender?.trim()){
            errors.gender = "Gender is required"
        }
        if (!data.tmc) {
            errors.tmc = 'You must accept the terms and conditions';
        }

        // console.log('Personal info validation errors:', errors);
        return errors
    },
    validateAcademicInfo(data){
        const errors = {}
        if(!data.grade?.trim()){
            errors.grade = "Grade is required"
        }
        if(!data.board?.trim()){
            errors.board = "Board is required"
        }
        if(!data.password?.trim()){
            errors.password = "Password is required"
        }
        if(!data.confirmPassword?.trim()){
            errors.confirmPassword = "Password is required"
        }
        if(data.password !== data.confirmPassword){
            errors.password ="Password does not match"
            errors.confirmPassword ="Password does not match"
        }
        return errors
    },
    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    },

    isValidMobile(mobile) {
        const mobileRegex = /^\d{10}$/;
        return mobileRegex.test(mobile);
    },
    isValidDob(dobValue) {
    const today = new Date();
    const dob = new Date(dobValue); // ensure it's a Date object

    if (isNaN(dob.getTime())) return "Invalid date format";

    if (dob > today) return "Date of birth cannot be in the future";

    const age = Math.floor((today - dob) / (365.25 * 24 * 60 * 60 * 1000));

    if (age < 5) return "Student must be at least 5 years old";
    if (age > 40) return "Please enter a valid date of birth";

    return ""; // ✅ No error
  },
    
        
}

